import { PriceOption } from '@/components/Product/ProductQtyRow'

/**
 * generation des paliers.
 * Si prices_current.max = 0 => prix unique
 */
const generatePriceOptions = (effectiveProduct): PriceOption[] => {
  // If prices_current array exists, use it directly
  if (effectiveProduct?.prices_current && effectiveProduct.prices_current.length > 0) {
    const mapped = effectiveProduct.prices_current.map(price => {
      // Convert all values to numbers to ensure consistency
      const mini = typeof price.mini === 'string' ? parseFloat(price.mini) : price.mini || 0
      const maxi = typeof price.maxi === 'string' ? parseFloat(price.maxi) : price.maxi || 0
      const cataloguePrice =
        typeof price.catalogue_price === 'string'
          ? parseFloat(price.catalogue_price)
          : price.catalogue_price || 0
      const priceSales =
        typeof price.price_sales === 'string'
          ? parseFloat(price.price_sales)
          : price.price_sales || 0
      const percentDiscount =
        typeof price.percent_discount === 'string'
          ? parseFloat(price.percent_discount)
          : price.percent_discount || 0

      return {
        quantity: mini,
        maxQuantity: maxi,
        originalPrice: cataloguePrice,
        discount: percentDiscount,
        finalPrice: priceSales,
      } as PriceOption
    })

    // Trier les paliers par quantité croissante et retourner tous les paliers
    mapped.sort((a, b) => Number(a.quantity) - Number(b.quantity))
    return mapped
  }

  // Pas de données de prix disponibles -> renvoyer un tableau vide
  return []
}

export default generatePriceOptions
